import {Button} from '@wandb/weave/components';
import * as Dialog from '@wandb/weave/components/Dialog';
import {Icon} from '@wandb/weave/components/Icon';
import React, {memo} from 'react';

import {envIsLocal} from '../../config';
import {ModelsSeatType} from './util';

type ChangeModelSeatConfirmationModalProps = {
  username: string;
  newModelSeat: ModelsSeatType;
  onConfirm: () => void;
  onClose: () => void;
  isCurrentOrgAdmin: boolean;
};

const getRestrictions = (seatType: ModelsSeatType) => {
  const commonRestrictions = ['Log runs to projects'];

  const viewerRestrictions = [
    'Create and edit reports',
    'Upload and edit artifacts',
    'Create workspaces',
    'Customize and save workspaces',
  ];

  const noAccessRestrictions = [
    'View runs in projects',
    'Create, edit, or view reports',
    'Upload, edit, or view artifacts',
    'View, customize, or save workspaces',
  ];

  if (seatType === ModelsSeatType.VIEWER) {
    return [...commonRestrictions, ...viewerRestrictions];
  } else if (seatType === ModelsSeatType.NOACCESS) {
    return [...commonRestrictions, ...noAccessRestrictions];
  }

  return [];
};

const ChangeModelSeatConfirmationModalComp = ({
  username,
  onConfirm,
  newModelSeat,
  onClose,
  isCurrentOrgAdmin,
}: ChangeModelSeatConfirmationModalProps) => {
  return (
    <Dialog.Root open={true} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay />
        <Dialog.Content className="w-[600px]">
          <Dialog.Title>
            <div className="align-center flex">Downgrade this model seat?</div>
          </Dialog.Title>
          <Dialog.Description className="mt-6 text-lg">
            {(newModelSeat === ModelsSeatType.VIEWER ||
              newModelSeat === ModelsSeatType.NOACCESS) && (
              <>
                <div>
                  When you downgrade <strong>{username}</strong>{' '}
                  {newModelSeat === ModelsSeatType.VIEWER
                    ? 'to a Models viewer'
                    : 'and remove Models access'}
                  {isCurrentOrgAdmin &&
                  (newModelSeat === ModelsSeatType.VIEWER ||
                    (newModelSeat === ModelsSeatType.NOACCESS &&
                      envIsLocal)) ? (
                    <span>
                      {' '}
                      they will{' '}
                      <span className="font-bold">
                        lose organization admin privileges
                      </span>{' '}
                      and can no longer:
                    </span>
                  ) : (
                    <span>, they can no longer:</span>
                  )}
                </div>
                <div className="mt-4 pl-5">
                  {getRestrictions(newModelSeat).map((restriction, index) => (
                    <div key={index} className="mt-4 flex items-center">
                      <Icon name="failed" className="pr-5 text-red-500" />{' '}
                      {restriction}
                    </div>
                  ))}
                </div>
              </>
            )}
          </Dialog.Description>
          <div className="justify-left mt-24 flex gap-8 text-lg">
            <Dialog.Close asChild>
              <div>
                <Button onClick={onConfirm} variant="destructive" size="large">
                  Downgrade
                </Button>
              </div>
            </Dialog.Close>
            <Dialog.Close asChild>
              <div>
                <Button onClick={onClose} variant="ghost" size="large">
                  Cancel
                </Button>
              </div>
            </Dialog.Close>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export const ChangeModelSeatConfirmationModal = memo(
  ChangeModelSeatConfirmationModalComp
);
